import React from 'react';
import CommentManagementComponent from '../../../components/admin/community/CommentManagementComponent';

const CommentManagement: React.FC = () => {
  return <CommentManagementComponent />;
};

export default CommentManagement;
